const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/MetaKatLocalizedText/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        translationMissing: 'Es scheint, dass die Übersetzung für diese Sprache fehlt.',
    },
    __RELATIVE_SOURCE_FILE__
);
